import type { SVGProps } from 'react';

const SvgRecent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M12 14h3c.55 0 1-.45 1-1s-.45-1-1-1h-2V8c0-.55-.45-1-1-1s-1 .45-1 1v5c0 .55.45 1 1 1"
    />
    <path
      fill="currentcolor"
      d="M12 3c-.22 0-.41.08-.57.2-.05.03-.1.05-.14.09-.05.05-.08.12-.11.18-.1.16-.18.33-.18.53s.07.38.18.54c.04.06.07.12.11.17.05.05.12.08.18.11.16.1.33.18.53.18 3.86 0 7 3.14 7 7s-3.14 7-7 7-7-3.14-7-7c0-.22-.09-.42-.21-.58-.03-.04-.05-.09-.08-.13l-.15-.12a1 1 0 0 0-.14-.07 1 1 0 0 0-.07-.03c-.05-.02-.1-.04-.16-.05s-.11-.01-.17-.01h-.04c-.12 0-.23.03-.34.07-.02 0-.04.02-.07.03-.1.05-.2.11-.29.19-.04.04-.06.09-.09.13-.12.17-.2.36-.2.58 0 4.96 4.04 9 9 9s9-4.04 9-9S16.96 3 12 3M8 6.07c.17 0 .34-.04.5-.13.48-.28.64-.89.36-1.37a1 1 0 0 0-1.37-.36h.01a.99.99 0 0 0-.37 1.36c.19.32.52.5.87.5m-3.43 2.8c.16.09.33.13.5.13.35 0 .68-.18.87-.5.27-.48.11-1.09-.37-1.37a.996.996 0 0 0-1.36.37 1 1 0 0 0 .36 1.37"
    />
  </svg>
);
export default SvgRecent;
